export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 py-10">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 md:flex-row md:items-center md:justify-between md:px-12">
        <img
          src={`${process.env.PUBLIC_URL}/te_logo.png`}
          alt="Tyre Empire"
          data-testid="footer-logo"
          className="h-9 w-auto self-start md:self-auto"
        />
        <p className="font-heading text-xs uppercase tracking-[0.25em] text-white/40">
          Tyre Empire — Your Trusted Tyre Store! Call us at{" "}
          <a
            href="tel:+916366437841"
            data-testid="footer-call-link"
            className="text-[#FFCC00] transition-colors duration-300 hover:text-white"
          >
            +91 63664 37841
          </a>{" "}
          · © 2026
        </p>
      </div>
    </footer>
  );
}
